import IDS from "@/utils/ids";

export function chunk(array, size) {
  const chunked_arr = [];
  for (let i = 0; i < array.length; i++) {
    const last = chunked_arr[chunked_arr.length - 1];
    if (!last || last.length === size) {
      chunked_arr.push([array[i]]);
    } else {
      last.push(array[i]);
    }
  }
  return chunked_arr;
}

export function stickToTop(el) {
  if (!el) return false;
  const scrollpos = window.scrollY;
  // const width = window.innerWidth;
  const top = 0;
  // let top = 64;

  // if (width < 640) top = 50;
  // else if (width <= 1024) top = 56;
  // else if (width >= 1440) top = 72;

  return scrollpos + top >= el.offsetTop;
}

export function gdpGroupName(val) {
  switch (val) {
    case 0:
    case "0":
      return "Low income";
    case 1:
    case "1":
      return "Lower middle income";
    case 2:
    case "2":
      return "Upper middle income";
    case 3:
    case "3":
      return "High income";
  }
}

export const daysBack = 1;

export const segments = [
  { name: "Total", options: [{ name: IDS.TOTAL, id: "TOTAL" }] },

  {
    name: "Por sexo",
    options: [
      { name: IDS.HOMBRE, id: "HOMBRE" },
      { name: IDS.MUJER, id: "MUJER" },
    ],
  },

  {
    name: "Por edad",
    options: [
      { name: IDS["18A34"], id: "18A34" },
      { name: IDS["35A54"], id: "35A54" },
      { name: IDS["55A74"], id: "55A74" },
      { name: IDS["75YMAS"], id: "75YMAS" },
    ],
  },

  {
    name: "Por clase social",
    options: [
      { name: IDS["GRUPO_I"], id: "GRUPO_I" },
      { name: IDS["GRUPO_II"], id: "GRUPO_II" },
      { name: IDS["GRUPO_III"], id: "GRUPO_III" },
      { name: IDS["GRUPO_IV"], id: "GRUPO_IV" },
      { name: IDS["GRUPO_V"], id: "GRUPO_V" },
      { name: IDS["NO_CODIFICABLE"], id: "NO_CODIFICABLE" },
    ],
  },

  {
    name: "Relación con el cáncer",
    options: [
      { name: IDS["SIN_RELACION"], id: "SIN_RELACION" },
      { name: IDS["RELACION_CERCANA"], id: "RELACION_CERCANA" },
      { name: IDS["EXPERIENCIA_PROPIA"], id: "EXPERIENCIA_PROPIA" },
    ],
  },
];
